import { render, staticRenderFns } from "./BridgeInfoCard.vue?vue&type=template&id=14935f8c"
import script from "./BridgeInfoCard.vue?vue&type=script&lang=js"
export * from "./BridgeInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports